module.exports = __webpack_public_path__ + "img/top1.15269c06.png";